import * as React from "react";
import cn from "classnames";
import styled, { css } from "../../../styled/index";
import {shadeAlternate} from "../../../styled/helpers";

interface Props {
  id: string;
  name: string;
  checked: boolean;
  title: React.ReactNode;
  value: string;
  required?: boolean;
  className?: string;
  label_only?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => any;
}

const Label = styled("label")`
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  font-size: ${({theme}) => theme.font.size}px;
  user-select: none;
  &:hover {
    input ~ .checkmark {
      background-color: ${({theme}) => shadeAlternate(0.2, theme.input.background)};
    }
  }
  input:checked ~ .checkmark {
    background-color: ${({theme}) => theme.colors.primary};
    border: 1px solid ${({theme}) => theme.colors.primary};
    &:after {
      display: block;
    }
  }
`;

const Input = styled("input")`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

const Checkmark = styled("span")`
  height: 18px;
  width: 18px;
  margin-right: 8px;
  background-color: ${({theme}) => shadeAlternate(0.1, theme.input.background)};
  border: 1px solid ${({theme}) => theme.input.border};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s all;
  &:after {
    content: "";
    display: none;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({theme}) => theme.colors.primary_text};
  }
`;

export const Radio: React.SFC<Props> = (props) => {

  const { id, name, required, title, value, onChange, checked, className } = props;

  return (
    <Label>
      <Input
        id={id}
        type="radio"
        className={cn(className)}
        name={name}
        onChange={onChange}
        checked={checked}
        value={value}
        required={required} />
      <Checkmark className="checkmark"/>
      {title}
    </Label>

  );
};
